import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../common/hooks/hooks";
import { setCustomerNote } from "../../checkoutSlice";
import { selectCustomerNote } from "../../checkoutSelectors";

const CustomerNoteForm: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const note = useAppSelector(selectCustomerNote);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(setCustomerNote(e.target.value));
  };

  return (
    <div className="customer-note-form">
      <label htmlFor="customer-note" className="customer-note-form__label">
        {t("paymentStep.customerNoteLabel", "Note to Seller (Optional)")}
      </label>
      <textarea
        id="customer-note"
        className="customer-note-form__textarea"
        placeholder={t(
          "paymentStep.customerNotePlaceholder",
          "Notes about your order, e.g. special notes for delivery."
        )}
        value={note}
        onChange={handleChange}
        rows={3}
      />
    </div>
  );
};

export default CustomerNoteForm;
